import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslationService } from '@spartacus/core';
import { EndasureTooltipPopUPComponent } from '../endasure-tooltip-pop-up/endasure-tooltip-pop-up.component';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-endasure-replacement-cost',
  templateUrl: './endasure-replacement-cost.component.html',
  styleUrls: ['./endasure-replacement-cost.component.scss'],
  standalone: false
})
export class EndasureReplacementCostComponent {
  private readonly destroy$ = new Subject<void>();
  constructor(public endasureService: EndasureService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.endasureService.replacementData$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        this.replacementCostForm.patchValue({
          replacementFleetCostPerActuator: data.replacementFleetCostPerActuator || 150.00,
          laborToInstallActuator: data.laborToInstallActuator || 65.00,
          totalCostPerFailedActuator: data.totalCostPerFailedActuator || 215.00,
          numberOfActuatorsReplacedPerYear: data.numberOfActuatorsReplacedPerYear || 270,
        });
      }
    })

    this.onFormChanges();

  }
  get form() {
    return this.replacementCostForm.controls;
  }

  onFormChanges(): void {
    this.replacementCostForm.get('replacementFleetCostPerActuator')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.replacementCostForm.get('laborToInstallActuator')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.storeDataOnChange();
  }

  calculateAndSetSum(): void {
    const replacementCost = +this.replacementCostForm.get('replacementFleetCostPerActuator')?.value || 0;
    const laborCost = +this.replacementCostForm.get('laborToInstallActuator')?.value || 0;
    const sum = replacementCost + laborCost;

    this.replacementCostForm.patchValue({
      totalCostPerFailedActuator: sum,
    });

  }


  replacementCostForm = new FormGroup({
    replacementFleetCostPerActuator: new FormControl(150.00, { validators: Validators.required }),
    laborToInstallActuator: new FormControl(65.00, { validators: Validators.required }),
    totalCostPerFailedActuator: new FormControl(215.00),
    numberOfActuatorsReplacedPerYear: new FormControl(270, { validators: Validators.required }),
  });

  endaSureNxt() {
    this.storeDataOnChange();
    this.endasureService.currentComponent$.next('currentProduct');

  }
  endaSureBack() {
    this.storeDataOnChange();
    this.endasureService.currentComponent$.next('fleetInfo');
  }

  storeDataOnChange() {

    if (this.replacementCostForm.valid) {
      this.endasureService.replacementData$.next(this.replacementCostForm.value);
    }
    else {
      this.replacementCostForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
